export const TIERS = {
  basic: {
    product_id: "prod_TzubQLcXVDa6IV",
    price_id: "price_1T1umDFO0FM1GDcazpjrE94R",
    name: "Basic",
    price: 5,
    searches: "2 / day",
  },
  pro: {
    product_id: "prod_Tzub5r29GDrImD",
    price_id: "price_1T1umRFO0FM1GDcaOopWrVQW",
    name: "Pro",
    price: 20,
    searches: "Unlimited",
  },
} as const;

export type PlanKey = "free" | "basic" | "pro";

export function getPlanFromProductId(productId: string | null): PlanKey {
  if (!productId) return "free";
  if (productId === TIERS.basic.product_id) return "basic";
  if (productId === TIERS.pro.product_id) return "pro";
  return "free";
}
